export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-10-bb96fa5ec3336b3b223111c2d165ea6a.png";